import { SET_INITIAL_SORT } from "../modules/savedItems/constants";
import { SET_ITEMS_TYPE } from "../modules/common/constants";
import { ITEMS_TYPE_CUSTOMER_ITEMS } from "../../constants";
import { initialise } from "./initialise/customerItems";
import { handleNotifyMeWarning } from "./handleNotifyMeWarning";

export const initialiseCustomerItems =
  ({ sortOption }) =>
  async dispatch => {
    dispatch({
      type: SET_ITEMS_TYPE,
      payload: { itemsType: ITEMS_TYPE_CUSTOMER_ITEMS }
    });
    dispatch({
      type: SET_INITIAL_SORT,
      payload: sortOption
    });
    await dispatch(initialise());
    dispatch(handleNotifyMeWarning());
  };
